import {visit} from 'unist-util-visit';
import type {Link, Parent, Root, Text} from 'mdast';
import {ArticleTitle} from '@types';

export function setArticleTitles(titles: ArticleTitle[]) {
    localStorage.setItem('articleTitles', JSON.stringify(titles));
}
export function transformInfoPageLinks(
    titles?: ArticleTitle[]
): (tree: Root) => void {
    return (tree: Root) => {
        const raw = localStorage.getItem('articleTitles');
        const articleTitles: ArticleTitle[] =
            titles ?? (raw ? JSON.parse(raw) : []);

        visit(tree, 'text', (node: Text, index, parent) => {
            if (!parent || index === undefined) return;
            const regex = /\[info:([a-z0-9_-]+)\]/gi;
            const segments: (Text | Link)[] = [];
            let lastIndex = 0;
            let match;

            while ((match = regex.exec(node.value)) !== null) {
                const [raw, slug] = match;
                const start = match.index;

                if (start > lastIndex) {
                    segments.push({
                        type: 'text',
                        value: node.value.slice(lastIndex, start),
                    } as Text);
                }

                const title =
                    articleTitles.find(a => a.slug === slug)?.title ?? slug;

                segments.push({
                    type: 'link',
                    url: `/article/${slug}`,
                    title: null,
                    children: [{type: 'text', value: `ℹ️ ${title}`}],
                } as import('mdast').Link);

                lastIndex = start + raw.length;
            }

            if (lastIndex < node.value.length) {
                segments.push({
                    type: 'text',
                    value: node.value.slice(lastIndex),
                } as Text);
            }

            if (segments.length > 0) {
                (parent as Parent).children.splice(index, 1, ...segments);
            }
        });
    };
}
